<div class="istate-transition-container">
  <div class="istate-list">
    <div class="istate-item istate-header">
      <span class="button-text">{{ config.name }}</span>
      <button class="icon-button" (click)="onEdit(config)">
        <i class="fas fa-pen-to-square"></i>
      </button>
    </div>
    <div
      #endStateOne
      *ngIf="config.endStateOne"
      class="istate-item w-100 bg-white">
      Path 1:
    </div>
    <div
      #endStateTwo
      *ngIf="config.endStateTwo"
      class="istate-item w-100 bg-white">
      Path 2:
    </div>
  </div>
</div>
